import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=680ab348&scoped=true"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=680ab348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ab348",
  null
  
)

export default component.exports